import React, { createContext, useContext, useEffect, useRef, useState } from "react";
const defaultConfig = {
    callToActionLabel: null,
    callToActionUrl: null,
    mainNavigation: [],
    metaNavigation: [],
    metaText: "",
    footerMail: "",
    footerPhone: "",
};
const PageConfigContext = createContext(defaultConfig);
export const PageConfigProvider = (props) => {
    const [pageConfig, setPageConfig] = useState(null);
    const configNode = useRef(document.querySelector("#pageconfig"));
    useEffect(() => {
        const loader = () => {
            setTimeout(() => {
                if (configNode.current) {
                    const data = JSON.parse(configNode.current.innerText);
                    setPageConfig(data);
                }
            }, 15);
        };
        document.addEventListener("DOMContentLoaded", loader);
        loader();
        return () => {
            document.removeEventListener("DOMContentLoaded", loader);
        };
    }, [configNode.current]);
    return (React.createElement(PageConfigContext.Provider, { value: pageConfig !== null && pageConfig !== void 0 ? pageConfig : defaultConfig }, props.children));
};
export const usePageConfig = () => {
    return useContext(PageConfigContext);
};
